export default __webpack_public_path__ + "static/media/TeamAccelerons_FirstDIV.db74d803.webp";